import UserList from "../UserList/Userlist"

const LearnUserList = () => {
  return <UserList />;
};

export default LearnUserList;
